/** Marker used when observability payload values are intentionally removed. */
export const REDACTED_VALUE = "[REDACTED]";
/** Marker used when redaction encounters a circular object reference. */
export const CIRCULAR_VALUE = "[Circular]";

const KEY_SEPARATOR_RE = /[^A-Za-z0-9]/g;
const SENSITIVE_OBSERVABILITY_KEY_RE =
  /(auth|authorization|code|cookie|customer|email|error|key|message|name|notes|password|phone|pin|reason|reference|secret|session|token)/;
const SENSITIVE_QUERY_KEY_RE = /(auth|authorization|code|key|password|pin|secret|session|token)/;
const URL_BEARING_KEY_RE = /(href|location|path|pathname|referer|referrer|resource|uri|url)/;

function normalizeKey(key: string): string {
  return key.replace(KEY_SEPARATOR_RE, "").toLowerCase();
}

/** Returns whether a URL query parameter key should be redacted. */
export function isSensitiveQueryKey(key: string): boolean {
  return SENSITIVE_QUERY_KEY_RE.test(normalizeKey(key));
}

/** Returns whether an observability object/event key is unsafe to emit. */
export function isSensitiveObservabilityKey(key: string): boolean {
  return SENSITIVE_OBSERVABILITY_KEY_RE.test(normalizeKey(key));
}

/** Returns whether a value should be URL-redacted instead of text-redacted. */
export function isUrlBearingObservabilityKey(key: string): boolean {
  return URL_BEARING_KEY_RE.test(normalizeKey(key));
}
